export const ConsolePageOptionInjectKey = 'ConsolePageOption'

export type Head = {
  /**
   * head: 头部左边接口数组，里面传组件名称
   */
  left: Array<string>
  /**
   * head: 头部右边接口数组，里面传组件名称
   */
  right: Array<string>
}

export type Navigation = {
  /**
   * bar: 内容接口数组，里面传组件名称
   */
  items: Array<string>
}

export type Left = {
  /**
   * logo: 图片地址
   */
  logo: string | undefined
  /**
   * logo: 内容接口数组，里面传组件名称
   */
  middle: Array<string>
}

export type Right = {
  title: Array<string>
}

export type Console = {
  /**
   * head: 控制台头部
   */
  head: Head
  /**
   * navigation: 控制台中间内容区域
   */
  navigation: Navigation
  /**
   * left: 控制台左边
   */
  left: Left
  /**
   * right: 控制台右边
   */
  right: Right
}

export type Layout = {
  collapsed?: boolean
  /**
   * console:控制台布局接口
   */
  console: Console
  cachedViews?: Array<string>
}

export type ConsolePageOption = {
  /**
   * path: 自定义路径
   */
  path: string
  /**
   * layout: 布局接口
   */
  layout: Layout
}
